module.exports = __webpack_public_path__ + "img/title9.bc142ec6.png";